import { UserRound, Building2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// Small switch on a ledger row: company money, or one director's personal spending.
export default function PersonalMenu({ value, directors, onChange, testId }) {
  const current = directors.find((d) => d.id === value);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={testId} title={current ? `Personal · ${current.name}` : "Company — click to mark as a director's personal spending"}
          className={`h-7 shrink-0 rounded-full border px-2 text-xs inline-flex items-center gap-1 transition-colors ${
            current ? "border-indigo-500/50 bg-indigo-500/10 text-indigo-500" : "border-transparent text-muted-foreground hover:border-border hover:text-foreground"}`}>
          <UserRound className="h-3.5 w-3.5" />{current ? current.name : ""}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Who carries this row?</DropdownMenuLabel>
        <DropdownMenuItem onSelect={() => onChange(null)} data-testid={`${testId}-company`}>
          <Building2 className="h-4 w-4 mr-2" /> Company
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {directors.map((d) => (
          <DropdownMenuItem key={d.id} onSelect={() => onChange(d.id)} data-testid={`${testId}-${d.name.toLowerCase()}`}>
            <UserRound className="h-4 w-4 mr-2" /> Personal · {d.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
